import axios from '@/axios'
import apiUrl from '@/axios/config'

const account = {
  //提交分数
  async sendScore(params) {
    return await axios.post('/uc/ucUpgrade/addQuestionnaireScore', params, { des: '直客wap提交分数', sTime: new Date().getTime() })
  },
  //图片上传 
  upLoadImg(params) { //图片上传
    return jQuery.ajax({
      type: 'post',
      data: params,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      processData: false,
      contentType: false,
      dataType: 'json',
      url: apiUrl.API_BASE_URL + '/uc/ucUpgrade/ucAccountUpgradeimg'
    })
  },
  //提交图片
  async addUpImg(params) {
    return await axios.post('/uc/ucUpgrade/addAccountUpgrade', params, { des: '直客wap提交图片', sTime: new Date().getTime() })
  },
}

export default account


// WEBPACK FOOTER //
// ./src/api/account.js